export default __webpack_public_path__ + "static/media/access-health-information_224x224.cf19e8ca.jpg";